import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { SaveResult } from "@/api/db/person-write";
import { orpc } from "@/client";

export function useSavePerson(onSaved: (result: SaveResult) => void) {
	const queryClient = useQueryClient();

	const { mutate, isPending, isError } = useMutation(
		orpc.people.save.mutationOptions({
			onSuccess: (result) => {
				queryClient.invalidateQueries({ queryKey: orpc.people.key() });

				onSaved(result);
			},
		}),
	);

	return { save: mutate, isPending, isError };
}
